<cap-beschreibung-table-wrapper>
  <span class="cap-table-wrapper-title" style="font-weight: bold">
    {{ "grundstueckflaeche" | translate }}
  </span>
  <ng-container class="cap-table-wrapper-content">
    <cap-list-loader
      [hasRight]="hasPermission && hasRight"
      [keineTranslateKey]="translateKey"
      [listLoader]="flaechenListLoader"
      [showTotal]="false"
      [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        <table class="cap-table-detail">
          <thead>
            <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
          </thead>
          <tbody>
            <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
          </tbody>
        </table>
      </div>
    </cap-list-loader>
    <ng-template #tableHeaders>
      <tr>
        <th style="width: 20%">{{ "Flaeche" | translate }}</th>
        @if (showQualitaetAV) {
          <th style="width: 20%">{{ "QualitaetAV" | translate }}</th>
        }
        <th style="width: 60%">{{ "DatumOderEntstehungOderRechtsgrund" | translate }}</th>
        @if (hasParzellenindex) {
          <th>{{ "Index" | translate }}</th>
        }
      </tr>
    </ng-template>

    <ng-template #tableRows>
      @for (flaeche of flaechenListLoader?.items; track flaeche) {
        @for (flaecheVersion of flaeche.versions; track flaecheVersion; let last = $last) {
          <tr>
            <td class="align-top">
              <span [capHistinfo]="flaecheVersion.histInfo" class="mitHistPrefix">
                {{ flaecheVersion.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m²
              </span>
              @if (flaecheVersion.projektMutation) {
                <span>
                  {{ "Projektmutation" | translate }}
                </span>
              }
              <cap-kompakt-timepoint [item]="flaecheVersion.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            @if (showQualitaetAV) {
              <td>
                @if (flaecheVersion.qualitaetAV) {
                  <span [capHistinfo]="flaecheVersion.histInfo">
                    {{ "QualitaetAV." + flaecheVersion.qualitaetAV | translate }}
                  </span>
                  <cap-kompakt-timepoint [item]="flaecheVersion.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
                }
              </td>
            }
            <td>
              @if (last) {
                @for (rechtsgrund of flaecheVersion.rechtsgruende; track rechtsgrund) {
                  <div>
                    @if (rechtsgrund) {
                      <p class="mb-0">
                        <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                      </p>
                    }
                  </div>
                }
              }
            </td>
            @if (hasParzellenindex) {
              <td [capHistinfo]="flaecheVersion.histInfo">
                {{ flaecheVersion.parzellenindex }}
              </td>
            }
          </tr>
        }
      }
    </ng-template>
  </ng-container>
</cap-beschreibung-table-wrapper>
